import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollConfig } from "../config/layout/scroll";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: scrollConfig.top,
      behavior: scrollConfig.behavior,
    });
  }, [location]);

  return null;
};

export default ScrollToTop;
